<form [formGroup]="billingFreeItemForm" (ngSubmit)="onSubmit()" class="mat-card-billing-free-item">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'billing.add-item' | translate }}</mat-card-title>
      <!-- <mat-card-subtitle>Veuillez saisir tout les champs</mat-card-subtitle> -->
    </mat-card-header>

    <mat-card-content>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.name' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="name" type="text" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.quantity' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="value" type="number" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.unitPriceHtva' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="priceHtva" type="number" autocomplete="off">
          <span matSuffix>€</span>
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.tva' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="tva" type="number" max="100" min="0" step="0.01" autocomplete="off">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.unitPriceTva' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="priceTva" type="number" autocomplete="off">
          <span matSuffix>€</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.totalHtva' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="totalHtva" type="number" autocomplete="off">
          <span matSuffix>€</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.totalTva' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="totalTva" type="number" autocomplete="off">
          <span matSuffix>€</span>
        </mat-form-field>
      </div>
    </mat-card-content>

    <mat-card-actions class="billing-free-item-card-action">
      <button mat-raised-button color="warn" (click)="onCancel()" type="button">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="billingFreeItemForm.invalid">
        <mat-icon>add</mat-icon> {{ 'button.add' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</form>